import { FIELD_BRILLIANCE_V2 } from '@/catalog/constants/fields/brillianceV2';
import { FIELD_CUT_PERFORMANCE_V2 } from '@/catalog/constants/fields/cutPerformanceV2';
import { FIELD_FIRE_MAP } from '@/catalog/constants/fields/fireMap';
import { FIELD_SCINTILLATION } from '@/catalog/constants/fields/scintillation';
import { FIELD_SCINTILLATION_MAP } from '@/catalog/constants/fields/scintillationMap';
import { FIELD_SHAPE_NORMALIZED_PERFORMANCE_V2 } from '@/catalog/constants/fields/shapeNormalizedPerformanceV2';
import brillianceGmc2 from '@/catalog/constants/filterInputMeta/brillianceGmc2';
import integralV2Gmc from '@/catalog/constants/filterInputMeta/integralV2Gmc';
import integralV2Smc from '@/catalog/constants/filterInputMeta/integralV2Smc';
import scintillationGmc from '@/catalog/constants/filterInputMeta/scintillationGmc';
import {
  ALLOW_BRILLIANCE_V2_VIEW,
  ALLOW_INTEGRAL_V2_VIEW,
  ALLOW_SCINTILLATION_VIEW,
  INTERNAL,
  securityManager,
} from '@/common/services/SecurityManager';
import { CrosstabAxis } from '@/product/types/CrosstabAxis';

export type SecurityActionType = Parameters<typeof securityManager.isGranted>[0];

export interface AccessGatedFieldRule {
  securityAction: SecurityActionType;
  sortFields: string[];
  filterFieldIds: string[];
  catalogFieldKeys: string[];
  crosstabAxes: CrosstabAxis[];
}

export const ACCESS_GATED_FIELDS: Record<string, AccessGatedFieldRule> = {
  scintillation: {
    securityAction: ALLOW_SCINTILLATION_VIEW,
    sortFields: ['scintillation.val', 'scintillation.rg'],
    filterFieldIds: [scintillationGmc.id],
    catalogFieldKeys: [FIELD_SCINTILLATION.key, FIELD_SCINTILLATION_MAP.key],
    crosstabAxes: [CrosstabAxis.Scintillation],
  },
  brillianceV2: {
    securityAction: ALLOW_BRILLIANCE_V2_VIEW,
    sortFields: ['brilliance.gmc2', 'brilliance.smc2', 'brilliance.val2', 'brilliance.rg2'],
    filterFieldIds: [brillianceGmc2.id],
    catalogFieldKeys: [FIELD_BRILLIANCE_V2.key],
    crosstabAxes: [],
  },
  fireMap: {
    securityAction: INTERNAL,
    sortFields: [],
    filterFieldIds: [],
    catalogFieldKeys: [FIELD_FIRE_MAP.key],
    crosstabAxes: [],
  },
  integralV2: {
    securityAction: ALLOW_INTEGRAL_V2_VIEW,
    sortFields: ['integralV2.rg', 'integralV2.smc', 'integralV2.val'],
    filterFieldIds: [integralV2Gmc.id, integralV2Smc.id],
    catalogFieldKeys: [FIELD_CUT_PERFORMANCE_V2.key, FIELD_SHAPE_NORMALIZED_PERFORMANCE_V2.key],
    crosstabAxes: [CrosstabAxis.ShapePerformanceV2, CrosstabAxis.GlobalPerformanceV2],
  },
};
